import i18n from 'src/i18n';

const configTable = () => {
  const tableColumns = [
    {
      prop: 'code',
      label: i18n.t('common_words.code'),
      minWidth: 100,
      sortable: true,
    },
    {
      prop: 'name',
      label: i18n.t('common_words.category'),
      minWidth: 150,
      sortable: true,
    },
    {
      prop: 'description',
      label: i18n.t('common_words.description'),
      minWidth: 250,
      sortable: true,
    },
  ];

  return { tableColumns };
};

export default configTable;
